import { Controller } from 'stimulus'
import $ from 'jquery'

export default class extends Controller {
  static targets = ['link']
  connect() {
    // アンカーリンクの遷移、スムーススクロール処理
    // 基準点の準備
    this.scrollPointList = []
    this.links = $(this.linkTargets)

    // スクロール位置の調整
    const pcAdjust = 30 // PC用
    const spAdjust = -40 // SP用
    this.adjust = 0

    //リサイズされたときの処理
    $(window).on('resize', () => {
      this.PositionCheck()
      this.adjust = $(window).width() > 999.98 ? pcAdjust : spAdjust
    })

    $(window).on('load scroll', () => {
      const currentYOffset = window.pageYOffset
      this.adjust = $(window).width() > 999.98 ? pcAdjust : currentYOffset < 94 ? spAdjust : spAdjust + 40
      this.PositionCheck()
      this.ScrollAnimation()
    })
  }

  // ページ内ナビゲーションをクリックした際のスムーススクロール
  linkClick(event) {
    const elmHash = $(event.target).attr('href')
    const headerH = $('.js-shared-header').outerHeight(true)
    const pos = Math.round($(elmHash).offset().top - headerH)
    $('body,html').animate({ scrollTop: pos - this.adjust }, 500)
    return false
  }

  // ナビゲーションに現在地のクラスを付与する
  ScrollAnimation() {
    const device = $(window).width() > 999.98 ? 'PC' : 'SP'
    const scroll = Math.round($(window).scrollTop()) + this.adjust
    this.links.removeClass('current')
    $('.c-tab-list-nav li a').removeClass('c-tab-list-nav-item-link--is-active')

    if (device === 'PC') {
      const NavElem = this.links
      const lastIndex = this.scrollPointList.length - 1
      this.scrollPointList.forEach((elm, idx) => {
        if (idx == 0 && scroll >= 0 && scroll < elm) {
          this.links.removeClass('current')
        } else if (scroll >= elm && scroll < this.scrollPointList[idx + 1]) {
          if (!$(NavElem[idx]).hasClass('disabled')) {
            $(NavElem[idx]).addClass('current')
          }
        } else if (idx == lastIndex && scroll >= this.scrollPointList[lastIndex]) {
          $(NavElem[idx]).addClass('current')
        }
      })
    }
  }

  // ターゲット要素の位置を取得する
  PositionCheck() {
    let scrollPointList = []
    // headerの高さを取得
    const headerH = $('.js-shared-header').outerHeight(true)
    // .js-scroll-pointクラスが付与されているエリアの位置を取得
    $('.js-scroll-point').each(function () {
      scrollPointList.push(Math.round(parseInt($(this).offset().top - headerH)))
    })
    this.scrollPointList = scrollPointList
  }
}
